import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {addToCartUrl} from "../../constants/api/soft-user/endpoints";

export const useAddToCart = ({userIsSoft}: {userIsSoft?: boolean}) => {
  const queryClient = useQueryClient();
  const axios = useAxios();

  async function postData(data: {course_recommendation_id: string, select_for_payment: boolean, program_id?: string}) {
    const payload = {
      course_recommendation_id: data.course_recommendation_id,
      select_for_payment: data.select_for_payment,
      // Conditionally include program_id in the payload if it exists
      ...(data.program_id && { program_id: data.program_id })
    };
    return axios.post(addToCartUrl(userIsSoft), payload)
  }

  return useMutation({
    mutationKey: ['add-to-cart'],
    mutationFn: postData,
    onMutate: () => {
      document.body.className = 'body-loading';
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['courses']})
        .then(() => document.body.removeAttribute('class'));
    }
  });
}
